import { ReactNode, useMemo } from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { zIndex, ZIndexSizeType } from 'presentations/views/styles';
interface Props {
  children: ReactNode;
  isOpen: boolean;
  onClose?: any;
  className?: string;
  anchor?: 'right' | 'left' | 'top' | 'bottom';
  swipeAreaWidth?: number;
  isDisableSwipeToOpen?: boolean;
  variant?: 'permanent' | 'persistent' | 'temporary' | undefined;
  zIndex?: ZIndexSizeType;
}
export default function Component(props: Props) {
  const container = useMemo(() => {
    return typeof window !== undefined ? window.document.body : undefined;
  }, []);

  return (
    <SwipeableDrawer
      className={props.className}
      container={container}
      anchor={props.anchor || 'bottom'}
      open={props.isOpen}
      onClose={props.onClose}
      onOpen={() => {}}
      swipeAreaWidth={props.swipeAreaWidth}
      disableSwipeToOpen={props.isDisableSwipeToOpen}
      style={{
        zIndex: zIndex(props.zIndex || 1200),
        // pointerEvents: 'none',
      }}
      ModalProps={{
        disableEnforceFocus: true,
        hideBackdrop: true,
      }}
    >
      <div style={{ height: '100vh' }}>{props.children}</div>
    </SwipeableDrawer>
  );
}
